import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/foto-profile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-47fd4d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column is-2" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card\" style=\"display:flex;justify-content:center;align-items:center;position:relative;border-radius:50%;border:#041f96 solid 5px;width:400px;height:350px;overflow:hidden;\" data-v-47fd4d88><div class=\"card-my\" data-v-47fd4d88><div class=\"my-image\" data-v-47fd4d88><figure class=\"image\" data-v-47fd4d88><img src=\"" + _imports_0 + "\" alt=\"Placeholder image\" data-v-47fd4d88></figure></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}